export default __webpack_public_path__ + "static/media/greenDot.773586e9.svg";